import { useState, useEffect } from "react";
import { MessageCircle, X, Bot, FileText, Search } from "lucide-react";
import AgentChatbot from "./agent_menu/AgentChatbot";
import AgentPage from "./agent_menu/AgentPage";
import chatbotIcon from "../../assets/images/mobile_chatbot.png";  // P6ix AI 아이콘

export default function AgentChat() {
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const [activeTool, setActiveTool] = useState(null);
  const [opening, setOpening] = useState(false);

  useEffect(() => {
    if (open) {
      setOpening(true);
      requestAnimationFrame(() => {
        setOpening(false);
      });
    }
  }, [open]);

  const toolButtons = [
    { id: "chatbot", label: "챗봇과 대화", icon: <Bot size={22} className="text-[#1A1B2E]" /> },
    { id: "page", label: "현재 페이지 분석", icon: <FileText size={22} className="text-[#1A1B2E]" /> },
  ];

  const handleToggle = () => {
    if (open) {
      setClosing(true);

      setTimeout(() => {
        setOpen(false);
        setClosing(false);
      }, 250); // 애니메이션 시간
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      {/* 툴 UI 표시 */}
      {activeTool === "chatbot" && <AgentChatbot onClose={() => setActiveTool(null)} />}
      {activeTool === "page" && <AgentPage onClose={() => setActiveTool(null)} />}

      {!activeTool && (
        <>
          {/* 메인 버튼 - P6ix AI (트렌디 & 공식적) */}
          <button
            onClick={handleToggle}
            className="fixed bottom-6 right-6 bg-gradient-to-br from-[#1A1B2E] to-[#2D2F4A] text-white px-5 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 z-50 z-[9999] no-print border border-white/10"
            style={{ boxShadow: '0 4px 20px rgba(26, 27, 46, 0.4)' }}
          >
            <span className="text-sm font-semibold tracking-wide">P6ix AI</span>
          </button>

          {/* Speed Dial 메뉴 */}
          {(open || closing) && (
            <div className="fixed bottom-28 right-10 flex flex-col gap-2 z-50">

              {toolButtons.map((tool, index) => {
                // 애니메이션 클래스: 열릴 때 vs 닫힐 때 분기
                const animationClass = closing
                  ? "animate-[fadeOutSmooth_0.25s_ease-out_forwards]"
                  : "animate-[fadeInUp_0.25s_ease-out_forwards]";

                const labelAnimation = closing
                  ? "animate-[labelOutSmooth_0.25s_ease-out_forwards]"
                  : "animate-[slideInLeft_0.25s_ease-out_forwards]";

                return (
                  <div
                    key={tool.id}
                    className={`flex items-center gap-3 justify-end
                      ${opening ? "opacity-0" : ""} 
                      ${closing ? "animate-fadeOutSmooth" : "animate-fadeInUp"}
                    `}
                    style={{ animationDelay: `${index * 0.05}s` }}
                  >
                    {/* 텍스트 라벨 */}
                    <div className={`bg-[#1A1B2E] text-white text-sm px-3 py-1 rounded-lg shadow ${labelAnimation}`}>
                      {tool.label}
                    </div>

                    {/* 원형 버튼 */}
                    <button
                      onClick={() => setActiveTool(tool.id)}
                      className={`
                        w-14 h-14 bg-white border shadow rounded-full 
                        flex items-center justify-center hover:scale-110 transition
                      `}
                    >
                      {tool.icon}
                    </button>
                  </div>
                );
              })}

            </div>
          )}
        </>
      )
      }

      {/* keyframes */}
      <style>{`
        /* 열릴 때 */
        @keyframes fadeInUp {
          0%   { opacity: 0; transform: translateY(10px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideInLeft {
          0%   { opacity: 0; transform: translateX(10px); }
          100% { opacity: 1; transform: translateX(0); }
        }
        @keyframes fadeOutSmooth {
          0%   { opacity: 1; transform: translateY(0) scale(1); }
          100% { opacity: 0; transform: translateY(6px) scale(0.85); }
        }
        @keyframes labelOutSmooth {
          0%   { opacity: 1; transform: translateY(0) translateX(0); }
          100% { opacity: 0; transform: translateY(6px) translateX(4px); }
        }
      `}</style>
    </>
  );
}
